// extracted by mini-css-extract-plugin
export var cartContainer = "_ph-4";
export var gray = "_ph-1";
export var itemContainer = "_ph-2";
export var itemDetails = "_ph-3";
export var strong = "_ph-0";